import { createFileRoute } from '@tanstack/react-router'
import LandHero from '@/components/custom/ui/landing/landHero';
import Homestays from '@/components/custom/ui/clients/tempula/homestay/homestays';
import homestaysConfig from '@/constant/config/clients/tempula/homestay/homestaysConfig';
import LandHeroConfig from '@/constant/config/landing/landHeroConfig';
import FooterCmp from '@/components/custom/ui/landing/footer';
import footerConfig from '@/constant/config/landing/footerConfig';




export const Route = createFileRoute('/_landing/home')({
  component: HomeComponent,
})

function HomeComponent() {
  return (
    <div>
      <LandHero {...LandHeroConfig} />
      <Homestays {...homestaysConfig} />
      <FooterCmp {...footerConfig} />
    </div>)
};

  